import Vue from 'vue'
import App from './App.vue'
import createPersistedState from 'vuex-persistedstate';
import Vuex from 'vuex'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VTooltip from 'v-tooltip'

function persistencePlugin() {
  return createPersistedState({
    key: 'challenge-directory-v2',
    storage: window.sessionStorage
  })
}

function getInitialStore() {
  return new Vuex.Store({
    plugins: [persistencePlugin()],
    state: {
      filters: {
        startingSoon: false,
        biggestPot: false
      },
      challengeList: [],
      modalFilteredChallengeList: [],
      fullFilteredChallengeList: [],
      modalFilterValues: {
        team: '',
        type: ''
      }
    },
    mutations: {
      updateStartingSoonFilter: function (state, newValue) { state.filters.startingSoon = newValue },
      updateBiggestPotFilter: function (state, newValue) { state.filters.biggestPot = newValue },
      updateChallengeList: function (state, newValue) {
        state.challengeList = newValue;
        state.modalFilteredChallengeList = newValue;
        state.fullFilteredChallengeList = newValue;
      },
      updateModalFilteredChallengeList: function (state, newValue) {
        state.modalFilteredChallengeList = newValue;
        state.fullFilteredChallengeList = newValue;
      },
      updateFullFilteredChallengeList: function (state, newValue) { state.fullFilteredChallengeList = newValue },
      resetChallengeList: function (state) {
        state.fullFilteredChallengeList = state.challengeList;
        state.modalFilteredChallengeList = state.challengeList;
        state.filters.startingSoon = false;
        state.filters.biggestPot = false;
        state.modalFilterValues.team = '';
        state.modalFilterValues.type = '';
      },
      updateModalFilterValues: function (state, newValue) {
        const { skipUpdateQuickFilters, ...restNewValue } = newValue
        state.modalFilterValues = restNewValue;
        if (!skipUpdateQuickFilters) {
          state.filters.startingSoon = false;
          state.filters.biggestPot = false;
        }
      }
    }
  })
}

Vue.use(Vuex);
Vue.use(VueAwesomeSwiper);
Vue.use(VTooltip)

// eslint-disable-next-line no-undef
export const STATIC_URL = staticUrl; // saved on participants/templates/dashboard/challenge-directory-v2/_challenge_directory_v2.html

export default new Vue({
  el: '#challenge-directory-v2-content',
  components: { App: App },
  store: getInitialStore(),
  template: '<App />'
})
